import {ReactNode} from "react";
import {useSidebar} from "../../basic/sidebar";
import {cn} from "../../../utils/utils";

interface BannerStackProps {
    children: ReactNode;
}

export function BannerStack({children}: BannerStackProps) {
    const {state} = useSidebar();

    return (
        <div className={cn(
            "pointer-events-none fixed top-4 right-0 left-0 z-50 px-4",
            state === "expanded" && "md:left-(--sidebar-width)"
        )}>
            <div className="mx-auto flex w-full max-w-3xl flex-col gap-3 [&>*]:pointer-events-auto">
                {children}
            </div>
        </div>
    );
}
